import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const GetAllJobs = async (
  workReqID,
  requestID,
  navigate
) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const queryParams = new URLSearchParams({
        workReqID: workReqID,
        requestID: requestID
      }).toString();

      const response = await fetch(
        `${dev_baseUrl}/Job/getAllJobs?${queryParams}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else if (response.ok && !data.isError) {
        return data.result;
      } else {
        console.error("Server error:", data);
        return [];
      }
    } catch (error) {
      console.error("Network error:", error);
      return [];
    }
  } else {
    console.warn("Access token is not available.");
    return { form: "Access token is missing." };
  }
};

export const GetAllFilteredJobs = async (
  payload,
  navigate
) => {
  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const queryParams = new URLSearchParams(payload).toString();

      const response = await fetch(
        `${dev_baseUrl}/Job/getAllJobs?${queryParams}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${accesstoken}`,
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else if (response.ok && !data.isError) {
        return data.result;
      } else {
        console.error("Server error:", data);
        return [];
      }
    } catch (error) {
      console.error("Network error:", error);
      return [];
    }
  } else {
    console.warn("Access token is not available.");
    return { form: "Access token is missing." };
  }
};
